var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.getClasses()},[_c('span',{directives:[{name:"i18n",rawName:"v-i18n"}]},[_vm._v(_vm._s(_vm.title))]),(_vm.withAdditional)?_c('span',{staticClass:"label-additional"},[_vm._v(_vm._s(_vm.additional))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }